const Logo = ({ dark = false, className = "h-9" }) => (
  <img
    src={dark ? "/logo-light.png" : "/logo.png"}
    alt="Book Kashmir — Kashmir Holiday Packages"
    className={`${className} w-auto`}
    data-testid="brand-logo-image"
  />
);

export default Logo;
